export default __webpack_public_path__ + "static/media/a023-02.f2c20782.png";